const views = {
  "download": require('./views/download.html'),
  "login": require('./views/login.html'),
  "password.forgot": require('./views/password_forgot.html'),
  "password.forgot-resend": require('./views/password_forgot_resend.html'),
  "password.reset": require('./views/password_reset.html'),
  "password.reset-success":  require('./views/password_reset_success.html'),
  "register": require('./views/register.html'),
  "join.from-referral": require('./views/from_referral.html'),
  "join.from-referral-success": require('./views/from_referral_success.html'),
  "join.setupkeycause": require('./views/setupkeycause.html'),
  "registeredkeycause":  require('./views/registeredkeycause.html'),
  "renewalkeycause":  require('./views/renewal/memberkeycause.html'),
  "renewalcause":  require('./views/renewal/registeredkeycause.html'),
  "verify": require('./views/verify.html'),
  "receipt": require('./views/receipt.html'),
  "selectpayment": require('./views/selectpayment.html'),
  "renewalselectpayment": require('./views/renewal/selectpayment.html'),
  "confirm_deletion": require('./views/confirm_deletion.html'),
};

function UsersConfig($stateProvider, ConfigEnvironmentProvider) {
  "ngInject";

  const greenback = ConfigEnvironmentProvider.getConfiguration('greenback');

  $stateProvider
    .state('confirm_deletion', {
      url: '/confirm_deletion/{uid}/{token}',
      views: {
        'main@': {
          templateUrl: views['confirm_deletion'],
          controller: function($stateParams, UserService, $scope, $state) {
            UserService.confirmDeletion({
              "subscriber_id": $stateParams.uid,
              "deletionToken": $stateParams.token
            }, (errMsg) => {
              console.log(errMsg);
              $state.go('error.500', {errMsg});
            }, (response) => {
            });
          }
        }
      }
    })
    .state('download', {
      url: '/download',
      views: {
        'main@': {
          templateUrl: views['download']
        }
      }
    })
    .state('logout', {
      url: '/logout',
      views: {
        'main@': {
          templateUrl: views['login'],
          controller: (AppAuthFactory, $state) => {
            AppAuthFactory.logout(() => {
              $state.go('login');
            })
          }
        }
      }
    })
    .state('login', {
      url: '/login',
      views: {
        'main@': {
          templateUrl: views['login'],
          controller: 'LoginCtrl'
        }
      }
    })
    .state('login.withemail', {
      url: '/withemail/{email}',
      views: {
        'main@': {
          templateUrl: views['login'],
          controller: 'LoginCtrl'
        }
      }
    })
    .state('login.verified', {
      url: '/verified',
      views: {
        'main@': {
          templateUrl: views['login'],
          controller: 'LoginCtrl'
        }
      }
    })
    .state('login.renewal', {
      url: '/renewal',
      views: {
        'main@': {
          templateUrl: views['login'],
          controller: 'LoginCtrl'
        }
      }
    })
    .state('password', {
      url: '/password',
      abstract: true,
      views: {
        'main@': {
          template: '<div ui-view/>',
          controller: 'LoginCtrl'
        }
      }
    })
      .state('password.forgot', {
        url: '/forgot',
        templateUrl: views['password.forgot']
      })
      .state('password.forgot-resend', {
        url: '/forgot-resend',
        templateUrl: views['password.forgot-resend']
      })
      .state('password.reset', {
        url: '/reset/{token}',
        templateUrl: views['password.reset'],
        controller: function($scope, $stateParams) {
          $scope.credentials.access_token = $stateParams.token;
        }
      })
      .state('password.reset-success', {
        url: '/reset-success',
        templateUrl: views['password.reset-success']
      })
    .state('join', {
      url: '/join',
      abstract: true,
      views: {
        'main@': {
          template: '<div ui-view/>',
          controller: 'RegisterCtrl',
          controllerAs: 'vm'
        }
      },
      resolve: {
        currentUser(AppAuthFactory, $q) {
          const deferred = $q.defer();
          AppAuthFactory.getCurrentUser((err, currentUser) => {
            deferred.resolve(currentUser);
          });
          return deferred.promise;
        },
        referringEntity(ReferrerService, Cause, $q, $http) {
          const referredBy = ReferrerService.getReferredBy();
          if(referredBy) {
            const deferred = $q.defer();
            const config = {
              params: {
                filter:{
                  where:{
                    id: referredBy.entity_id
                  }
                },
                templating:{
                  subentity_id: referredBy.subentity_id
                }
              }
            };
            $http.get(`${greenback}api/causes/findWithSubentity`, config)
              .then((entity) => {
                entity.data.entityContainerClass = referredBy.entity_type + referredBy.entity_id;
                console.log('Resolved referring entity', entity);
                deferred.resolve(entity.data);
              })
              .catch((err) => {
                console.error(err);
                deferred.resolve();
              });

            return deferred.promise;
          }
        }
      }
    })
      .state('join.setup', {
        url: '/setup',
        templateUrl: views['register'],
        controller: function($scope, referringEntity, currentUser) {
          $scope.vm.entity = referringEntity;
        }
      })
      .state('join.setup-referred-by', {
        url: '/setup-referred-by',
        templateUrl: views["register"],
        controller: function($state, $stateParams, ReferrerService) {
          ReferrerService.processReferral($state, $stateParams, function(err, hasReferrer) {
            if(!hasReferrer || err) {
              console.error(err || new Error(`Could not get referrer from state params ${stateParams}`));
              //they attempted to process an invalid referral
              $state.go("error.500", {errMsg: "The link that you selected is not valid. Please try again. If the error persists, select Report Error and let us help you resolve the issue! RUC500"});
            }
            else {
              $state.go('join.setup', null, {reload: true});
            }
          });
        }
      })
          .state('join.setup-referred-by.default', {
            url: '/default/{entity_type}/{entity_id}/*hash',
          })
          .state('join.setup-referred-by.subentity', {
            url: '/subentity/{entity_type}/{entity_id}/{subentity_id}/*hash',
          })
          .state('join.setup-referred-by.referrer', {
            url: '/referrer/{entity_type}/{entity_id}/{referrer_id}/*hash',
          })
          .state('join.setup-referred-by.subentity-referrer', {
            url: '/subentity-referrer/{entity_type}/{entity_id}/{subentity_id}/{referrer_id}/*hash',
          })
      .state('join.from-referral', {
        url: '/from-referral/{access_token}',
        templateUrl: views['join.from-referral'],
        resolve: {
          registered: function($q, $stateParams, Subscriber) {
            const deferred = $q.defer();
            const { access_token } = $stateParams;
            Subscriber.getByAccessToken({access_token}).$promise.then((res) => {
              deferred.resolve(res);
            }).catch((err) => {
              deferred.resolve(err);
            });
            return deferred.promise;
          }
        },
        controller: function(registered, AccountService, UserService, $stateParams, $scope, $state) {

          if(!registered.id) {
            return $state.go("error.500", {errMsg: "Session Expired. Please Re-Submit Password Reset Request. (RUC404)"});
          }

          $scope.credentials = {
            "access_token": $stateParams.access_token,
            "password": null,
            "confirm_password": null,
            "from_invitation": true
          };

          $scope.onResetPasswordSubmit = function() {
            if($scope.credentials.password !== $scope.credentials.confirm_password) {
              $scope.validationError = "Passwords do not match. Please try again.";
              return;
            }
            //to catch non html5 browsers
            else if(!AccountService.matchesCriteriaPassword($scope.credentials.password)) {
              $scope.validationError = $scope.criteria.password;
              return;
            }
            else {
              UserService.resetPass($scope.credentials).then(function(result) {
                $scope.validationError = undefined;
                $state.go("join.from-referral-success");
              }).catch(function(err) {
                console.error(err);
                if(err.data === "Unauthorized") {
                  $scope.validationError = "Session Expired. Please Re-Submit Password Reset Request";
                }
                else {
                  $scope.validationError = "Unknown Error Occured. Please Re-Submit Password Reset";
                }
              });
            }
          }
        }
      })
      .state('join.from-referral-success', {
        url: '/from-referral-success',
        templateUrl: views['join.from-referral-success']
      })
      .state('join.setupkeycause', {
        url: '/setupkeycause',
        templateUrl: views['join.setupkeycause'],
        controller: function($scope, referringEntity) {
          $scope.vm.entity = referringEntity;
        }
      })
      .state('join.registeredkeycause', {
        url: '/registeredkeycause',
        templateUrl: views["registeredkeycause.html"]
      })
      .state('join.setup-reconvene', {
        url: '/setup-reconvene/{subscriber_id}/*verificationToken',
        templateUrl: views["register"],
        controller: function($scope, $state, $stateParams, ReferrerService, AppAuthFactory, UserService, LoopBackAuthGreenback) {
          UserService.processReconvention($stateParams, (errMsg) => {
            $state.go('error.500', {errMsg});
          }, (response) => {
            LoopBackAuthGreenback.setUser(undefined, response.id, response);
            LoopBackAuthGreenback.save();
            $state.go('join.memberkeycause', null, {reload: true});
          });
        },
        controllerAs: 'vm'
      })
      .state('join.memberkeycause', {
        url: '/memberkeycause',
        templateUrl: views["registeredkeycause"],
        resolve: {
          availableCauses: availableCausesResolver
        },
        controller: function(availableCauses, referringEntity, currentUser, $scope, $state) {
          "ngInject";
          if(currentUser.subscription && currentUser.subscription.id) return $state.go('join.renewal');
          const vm = angular.extend(this, $scope.$parent.vm);
          $scope.$parent.vm.causes = [];
          angular.forEach(availableCauses, function(cause, key) {
            cause = vm.prepareCauseForDisplay(cause);
            $scope.$parent.vm.causes.push(cause);
          });
          $scope.$parent.vm.entity = referringEntity;
          console.log($scope.$parent.vm);
        }
      })
      .state('join.renewal', {
        url: '/renewal',
        templateUrl: views["renewalcause"],
        resolve: {
          availableCauses: availableCausesResolver,
        },
        controller: renewalController
      })
      .state('join.renewalkey', {
        url: '/renewalkey',
        templateUrl: views["renewalkeycause"],
        resolve: {
          availableCauses: availableCausesResolver
        },
        controller: renewalController
      })
      .state('join.selectpayment', {
        url: '/selectpayment',
        templateUrl: views["selectpayment"],
        controller: function(referringEntity, $scope, $state) {
          "ngInject";

          var vm = angular.extend(this, $scope.$parent.vm);

          console.log(vm);

          $scope.vm.registrationObject = JSON.stringify($scope.vm.registration);

          if(!vm.registration.selected_cause) {
            $state.go("join.memberkeycause");
          }
          else {
            $scope.vm.entity = referringEntity;
          }
        }
      })
      .state('join.renewalselectpayment', {
        url: '/renewalselectpayment',
        templateUrl: views["renewalselectpayment"],
        controller: function(referringEntity, $scope, $state) {
          "ngInject";

          var vm = angular.extend(this, $scope.$parent.vm);

          console.log(vm);

          $scope.vm.registrationObject = JSON.stringify($scope.vm.registration);

          if(!vm.registration.selected_cause) {
            $state.go("join.renewal");
          }
          else {
            $scope.vm.entity = referringEntity;
          }
        }
      })
      .state('join.verify', {
        url: '/verify/{uid}/{token}',
        templateUrl: views["verify"],
        controller: function($stateParams, ReferrerService, UserService, $scope, $state) {
          var vm = $scope.$parent.vm;
          UserService.processReconvention({
            "subscriber_id": $stateParams.uid,
            "verificationToken": $stateParams.token
          }, (errMsg) => {
            console.log(errMsg);
            $state.go('error.500', {errMsg});
          }, (response) => {
            vm.verification.uid = $stateParams.uid;
            vm.verification.token = $stateParams.token;
          });
        }
      })
      .state('join.receipt', {
        url: '/receipt',
        templateUrl: views["receipt"],
        controller: 'PaymentPaypalCtrl'
      })
      .state('join.receipt-stripe', {
        url: '/receipt-stripe',
        templateUrl: views["receipt"],
        controller: 'PaymentStripeCtrl'
      });

      function availableCausesResolver(ReferrerService, currentUser) {
        ReferrerService.setCurrentUser(currentUser);
        if(ReferrerService.hasReferrerAndEntityId()) {
          return ReferrerService.getCausesForReferral();
        }
        return ReferrerService.getActiveCausesJoinableFromGeneric();
      }

      function renewalController(availableCauses, referringEntity, currentUser, $scope, $state) {
        "ngInject";
        if(!currentUser.subscription || !currentUser.subscription.id) return $state.go('join.memberkeycause');
        $scope.$parent.vm.paymentRoute = "join.renewalselectpayment";
        const vm = angular.extend(this, $scope.$parent.vm);
        $scope.$parent.vm.causes = [];
        angular.forEach(availableCauses, function(cause, key) {
          cause = vm.prepareCauseForDisplay(cause);
          $scope.$parent.vm.causes.push(cause);
        });
        $scope.$parent.vm.entity = referringEntity;
        console.log($scope.$parent.vm);
      }
}

export default UsersConfig;



// WEBPACK FOOTER //
// ./js/containers/users/users.config.js